import { useCallback } from "react";

import { SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";

import colors from "core/resources/theme/colors";

import OpcaoItem from "./OpcaoItem";
import { showConfirm } from "infra/helpers/alerta";
import Button from "ui/components/Button";

import { Box, Text } from "@chakra-ui/react";
import { SortableContainerComponent } from "components/SortableContainerComponent";

const SortableItem = SortableElement(
  ({ value, i, onChangePergunta, handleAddOpcao, onRemovePergunta }: any) => {
    return (
      <OpcaoItem
        value={value}
        index={i}
        handleAddOpcao={handleAddOpcao}
        onChangePergunta={onChangePergunta}
        onRemovePergunta={onRemovePergunta}
      />
    );
  }
);

function QuestaoOpcoes({ value, onChange }: any) {
  const onRemovePergunta = (i: any) => {
    showConfirm("Deseja realmente excluir a resposta ?").then(
      ({ isConfirmed }) => {
        if (isConfirmed) {
          const items = [
            ...value.filter((_item: any, index: number) => index !== i),
          ];

          onChange(items);
        }
      }
    );
  };

  const onChangePergunta = useCallback(
    (index: number, prop: string, v: any) => {
      const newArray = value || [];

      newArray[index][prop] = v;

      onChange([...newArray]);
    },
    [onChange, value]
  );

  const onSortEnd = ({ oldIndex, newIndex }: any) => {
    value = arrayMove(value, oldIndex, newIndex);

    value.forEach((_item: any, i: number) => {
      value[i].ordem = i + 1;
    });

    onChange([...value]);
  };

  const handleAddOpcao = () => {
    const itemAdd: any = { editando: true };

    onChange([...(value || []), itemAdd]);
  };

  const opcoes = value || [];

  return (
    <Box>
      <Text fontWeight="500" fontSize={18} mb={1}>
        Respostas
      </Text>

      <br />

      <SortableContainerComponent onSortEnd={onSortEnd} useDragHandle>
        {opcoes?.map((item: any, index: number) => (
          <SortableItem
            key={`item-${index}`}
            onChangePergunta={onChangePergunta}
            onRemovePergunta={() => onRemovePergunta(index)}
            handleAddOpcao={handleAddOpcao}
            index={index}
            i={index}
            value={item}
          />
        ))}
      </SortableContainerComponent>

      <Box style={{ clear: "both", paddingLeft: 38, paddingRight: 148 }}>
        <Button
          onClick={() => {
            handleAddOpcao();
          }}
          isFullWidth
          style={{ textAlign: "left", paddingLeft: 32 }}
        >
          <i className="mdi mdi-plus-circle" style={{ color: colors.red500 }} />{" "}
          <span style={{ color: colors.red500, paddingLeft: 8 }}>
            Adicionar Opção
          </span>
        </Button>
      </Box>
    </Box>
  );
}

export default QuestaoOpcoes;
